import { Amplitude, Analytics, Experiments, UserProps, Event } from "./types.ts";

export class AmplitudeAnalytics implements Analytics {
  analyticsUId: string | null;
  amplitude?: Amplitude;
  experiments?: Experiments;

  constructor(analyticsUId: string | null, amplitude?: Amplitude, experiments?: Experiments) {
    this.analyticsUId = analyticsUId;
    this.amplitude = amplitude;
    this.experiments = experiments;
  }

  userPropsWithAnalyticsUId(userProps: UserProps): UserProps {
    return {
      ...(this.analyticsUId && { user_id: this.analyticsUId }),
      ...userProps,
    };
  }

  async track({ name, props }: Event, user: UserProps = {}): Promise<void> {
    try {
      this.amplitude?.track(name, props, this.userPropsWithAnalyticsUId(user));
    } catch (error) {
      globalThis?.console?.error(error);
    }
  }

  async updateUser(userProps: UserProps): Promise<void> {
    try {
      this.amplitude?.identify(this.userPropsWithAnalyticsUId(userProps));
    } catch (error) {
      globalThis?.console?.error(error);
    }
  }

  async getVariant(experimentKey: string): Promise<string | null> {
    try {
      await this.experiments?.fetch(this.analyticsUId ? { user_id: this.analyticsUId } : {});

      return this.experiments?.variant(experimentKey)?.value ?? null;
    } catch (error) {
      globalThis?.console?.error(error);
      return null;
    }
  }
}
